export default class WordItem {
    constructor(manual = false, word = '', itemId = undefined) {
        this.word = word
        this.itemId = itemId
        this.manual = manual
    }
}
